import axios from 'axios'
import { useAuthStore } from '../stores/authStore'
import { queryClient } from './queryClient'

// In production, set VITE_API_BASE_URL at build time:
//   VITE_API_BASE_URL=https://api.myapps.flexilabs.net npm run build
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
})

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // Only set Content-Type if not already specified.
  // FormData must NOT have Content-Type set here (browser sets the multipart boundary).
  // Login uses application/x-www-form-urlencoded set explicitly in the call.
  if (!config.headers.getContentType() && !(config.data instanceof FormData)) {
    config.headers.setContentType('application/json')
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || ''
      // Only force logout for auth endpoints, not for file API 401s
      // (FilesApi 401 means the service token failed, not the user session)
      if (!url.startsWith('/files/') && !url.startsWith('/tickets/')) {
        useAuthStore.getState().logout()
        queryClient.clear()
        // Hard redirect with reason — clears all in-memory state
        window.location.href = '/login?reason=expired'
      }
    }
    return Promise.reject(error)
  }
)

export default api